$(document).ready(function(){

  jQuery(document).on('click', 'body.body-template-page-newsletter-apertura a[href^="#"]', function (event) {
    event.preventDefault();
    
    jQuery('html, body').animate({
        scrollTop: (jQuery(jQuery.attr(this, 'href')).offset().top - 75)
    }, 500);
  });

  setTimeout(() => {
    if($('input[value="Iniziale"]:checked').length > 0 || $('input[value="Initial"]:checked').length > 0){
      console.log('scendi');
      $('.tpo_option-set-wrapper').slideDown();
    }

    $('.tpo_option-input').on('input', function() {
      var value = $(this).val();
      if (value.length > 1) {
        $(this).val(value.charAt(0));
      }
    });
  }, 1000);
  
  $('.product-form__controls-group label').on('click', function(){
    if($(this).prev().val() == "Iniziale" || $(this).prev().val() == "Initial"){
      $('.tpo_option-set-wrapper').slideDown();
    }else{
      $('.tpo_option-set-wrapper').slideUp();
    }
  })
  
})